import { IoIosArrowRoundForward } from "react-icons/io";
import { Link } from "react-router-dom";

const ServiceHome = ({ images, title, content, link }) => {
  return (
    <>
      <div className="h-[310px] w-[280px] group rounded-lg  hover:bg-[#e7f4fb]  border-none  mt-4  shadow-md ">
        <div className=" ">
          <img src={images} className="h-[230px] w-[310px]  rounded-t-lg " />
        </div>
        <div className="py-2 text-center items-center group-hover:text-black ">
          <div className="">
            <span className=" font-roboto font-bold text-start text-xl leading-4">
              {title}
            </span>
          </div>
          <div className="items-center content-center justify-end px-2 flex gap-3 pt-2">
            <p className=" text-center font-thin  text-md font-roboto">
              {content}
            </p>
            <Link to={link} className="text-black  text-center ">
              <IoIosArrowRoundForward className="text-3xl bg-[#e7f4fb] hover:bg-white rounded-full  text-end" />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceHome;
